// extracted by mini-css-extract-plugin
export var btnContainer = "index-module--btnContainer--WQq1c";
export var featuredArticleContainer = "index-module--featuredArticleContainer--4+2da";
export var sectionArticles = "index-module--sectionArticles--xyBfj";